"use client";

import { FormStatus } from "@/components/form/Form.js";
import { useFormState } from "@rosette/web_components/src/form/FormStateContext.js";
import type { ButtonTone } from "@rosette/web_components/src/ui/Button.js";
import { Button } from "@rosette/web_components/src/ui/Button.js";


interface SubmitButtonProps {
    tone?: ButtonTone;
    label?: string;
}


/**
 * A Form's full-width submit button, with the submission's status below
 * it. It is disabled only while submitting: an invalid form still
 * submits, and the Form reports why instead.
 */
export function SubmitButton({ tone = "accent", label }: SubmitButtonProps) {
    const formState = useFormState();
    return (
        <>
            <Button
                className="w-full"
                tone={tone}
                type="submit"
                disabled={!!formState.submitFormIsPending}
                title={formState.submitFormIsPending ? "Processing..." : undefined}>

                {label ?? "Submit"}
            </Button>

            <FormStatus />
        </>
    );
}
